import { render, staticRenderFns } from "./perintahbayar.vue?vue&type=template&id=3ac92dd4"
import script from "./perintahbayar.vue?vue&type=script&lang=js"
export * from "./perintahbayar.vue?vue&type=script&lang=js"
import style0 from "./perintahbayar.vue?vue&type=style&index=0&id=3ac92dd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports